import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/AutomationRules.css';

function AutomationRules() {
  const [rules, setRules] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingRule, setEditingRule] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [fieldMappings, setFieldMappings] = useState({});
  const [misaFields, setMisaFields] = useState({});
  const [loadingMisaFields, setLoadingMisaFields] = useState(false);
  
  const [formData, setFormData] = useState({
    rule_name: '',
    rule_type: 'order_delivered',
    template_id: '',
    delivery_statuses: ['Đã giao hàng', 'Hoàn thành'],
    enabled: true,
    priority: 1
  });

	const ruleTypes = [
	  { value: 'order_delivered', label: 'Đơn hàng đã giao', entity: 'sale_orders' },
	  { value: 'birthday', label: 'Sinh nhật khách hàng', entity: 'contacts' },
	  { value: 'payment_reminder', label: 'Nhắc thanh toán', entity: 'sale_orders' },
	  { value: 'order_confirmed', label: 'Xác nhận đơn hàng', entity: 'sale_orders' },
	  { value: 'stock_alert', label: 'Cảnh báo tồn kho', entity: 'stocks' },
	  { value: 'product_promo', label: 'Khuyến mãi sản phẩm', entity: 'products' }
	];

  useEffect(() => {
    fetchRules();
    fetchTemplates();
    fetchMISAFields();
  }, []);

  const fetchRules = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://zns.nagen.vn/api/automation/rules', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRules(response.data.data || []);
    } catch (error) {
      console.error('Error fetching rules:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://zns.nagen.vn/api/templates', {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Chỉ lấy templates active
      const activeTemplates = response.data.data.filter(t => t.status === 'active');
      setTemplates(activeTemplates);
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const fetchMISAFields = async () => {
  setLoadingMisaFields(true);
  try {
    const token = localStorage.getItem('token');
    
    const fieldsData = {};
    
    // Fetch fields cho từng entity type
    for (const ruleType of ruleTypes) {
      const response = await axios.get(
        `https://zns.nagen.vn/api/misa/fields?entity_type=${ruleType.entity}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      fieldsData[ruleType.value] = response.data.data || [];
    }
    
    setMisaFields(fieldsData);
    
    console.log('MISA Fields loaded:', fieldsData);
    
  } catch (error) {
    console.error('Error fetching MISA fields:', error);
    alert('Không thể tải fields từ MISA. Sử dụng danh sách mặc định.');
  } finally {
    setLoadingMisaFields(false);
  }
};

  const testMISAConnection = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        'https://zns.nagen.vn/api/misa/test',
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      console.log('MISA Test Result:', response.data);
      
      if (response.data.success) {
        alert(`✅ Kết nối MISA thành công!\n\nCó ${response.data.data.available_fields.length} fields khả dụng.`);
      }
    } catch (error) {
      alert('❌ Không thể kết nối MISA: ' + error.message);
    }
  };

  const handleTemplateChange = (templateId) => {
    setFormData({...formData, template_id: templateId});
    
    const template = templates.find(t => t.id === parseInt(templateId));
    if (template) {
      setSelectedTemplate(template);
      
      // Parse params
      const params = JSON.parse(template.params || '[]');
      
      // Tạo mapping mặc định dựa trên tên param
      const defaultMappings = {};
      params.forEach(param => {
        const paramName = param.name || param;
        
        // Auto-suggest mapping
        if (paramName.toLowerCase().includes('customer') || paramName.toLowerCase().includes('khach_hang') || paramName.toLowerCase().includes('ten')) {
          defaultMappings[paramName] = 'contact_name|account_name';
        } else if (paramName.toLowerCase().includes('product') || paramName.toLowerCase().includes('san_pham')) {
          defaultMappings[paramName] = 'sale_order_product_mappings[].product_code';
        } else if (paramName.toLowerCase().includes('ma_kh') || paramName.toLowerCase().includes('order') || paramName.toLowerCase().includes('don_hang')) {
          defaultMappings[paramName] = 'sale_order_no';
        } else if (paramName.toLowerCase().includes('ngay') || paramName.toLowerCase().includes('date')) {
          defaultMappings[paramName] = 'book_date';
        } else if (paramName.toLowerCase().includes('gia_tri') || paramName.toLowerCase().includes('amount') || paramName.toLowerCase().includes('tien')) {
          defaultMappings[paramName] = 'sale_order_amount';
        } else {
          defaultMappings[paramName] = '';
        }
      });
      
      setFieldMappings(defaultMappings);
    }
  };

  const handleMappingChange = (paramName, misaField) => {
    setFieldMappings({
      ...fieldMappings,
      [paramName]: misaField
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const token = localStorage.getItem('token');
      
      // Chuẩn bị trigger_conditions dựa trên rule_type
      let trigger_conditions = {};
      
      if (formData.rule_type === 'order_delivered') {
        trigger_conditions = {
          delivery_status: formData.delivery_statuses
        };
      } else if (formData.rule_type === 'birthday') {
        trigger_conditions = {
          check_date: 'birthday_date'
        };
      }
      
      const payload = {
        rule_name: formData.rule_name,
        rule_type: formData.rule_type,
        template_id: parseInt(formData.template_id),
        trigger_conditions: trigger_conditions,
        field_mapping: fieldMappings,
        enabled: formData.enabled ? 1 : 0,
        priority: parseInt(formData.priority)
      };

      if (editingRule) {
        // Update
        await axios.put(
          `https://zns.nagen.vn/api/automation/rules/${editingRule.id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Cập nhật automation rule thành công!');
      } else {
        // Create
        await axios.post(
          'https://zns.nagen.vn/api/automation/rules',
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Tạo automation rule thành công!');
      }
      
      setShowModal(false);
      setEditingRule(null);
      resetForm();
      fetchRules();
      
    } catch (error) {
      console.error('Error saving rule:', error);
      alert('Lỗi: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleToggle = async (ruleId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.patch(
        `https://zns.nagen.vn/api/automation/rules/${ruleId}/toggle`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchRules();
    } catch (error) {
      console.error('Error toggling rule:', error);
      alert('Lỗi khi bật/tắt rule');
    }
  };

  const handleDelete = async (ruleId) => {
    if (!window.confirm('Bạn có chắc muốn xóa automation rule này?')) return;
    
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `https://zns.nagen.vn/api/automation/rules/${ruleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Xóa automation rule thành công!');
      fetchRules();
    } catch (error) {
      console.error('Error deleting rule:', error);
      alert('Lỗi khi xóa rule');
    }
  };

  const handleEdit = (rule) => {
    setEditingRule(rule);
    
    const conditions = JSON.parse(rule.trigger_conditions);
    const mappings = rule.field_mapping ? JSON.parse(rule.field_mapping) : {};
    
    setFormData({
      rule_name: rule.rule_name,
      rule_type: rule.rule_type,
      template_id: rule.template_id,
      delivery_statuses: conditions.delivery_status || ['Đã giao hàng'],
      enabled: rule.enabled === 1,
      priority: rule.priority
    });
    
    setFieldMappings(mappings);
    
    // Load template
    const template = templates.find(t => t.id === rule.template_id);
    if (template) {
      setSelectedTemplate(template);
    }
    
    setShowModal(true);
  };

  const resetForm = () => {
    setFormData({
      rule_name: '',
      rule_type: 'order_delivered',
      template_id: '',
      delivery_statuses: ['Đã giao hàng', 'Hoàn thành'],
      enabled: true,
      priority: 1
    });
    setSelectedTemplate(null);
    setFieldMappings({});
  };

  const handleStatusChange = (status, checked) => {
    if (checked) {
      setFormData(prev => ({
        ...prev,
        delivery_statuses: [...prev.delivery_statuses, status]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        delivery_statuses: prev.delivery_statuses.filter(s => s !== status)
      }));
    }
  };

  const renderConditionsPreview = () => {
    if (formData.rule_type === 'order_delivered') {
      return (
        <div className="conditions-preview">
          <strong>Điều kiện:</strong> Khi đơn hàng có trạng thái giao hàng là{' '}
          <code>{formData.delivery_statuses.join(', ')}</code>
        </div>
      );
    } else if (formData.rule_type === 'birthday') {
      return (
        <div className="conditions-preview">
          <strong>Điều kiện:</strong> Khi ngày sinh nhật khách hàng trùng với ngày hôm nay
        </div>
      );
    }
    return null;
  };

  if (loading) {
  return (
    <div className="main-content">
      <div className="loading">Đang tải...</div>
    </div>
  );
}

return (
  // Loại bỏ div className="main-content" lặp lại ở đây.
  // Component này sẽ được render trực tiếp vào div .main-content từ ProtectedRoute (App.js)
  <> 
    <div className="automation-header">
      <h1>Quản lý Automation Rules</h1>
      <div className="header-actions">
        <button 
          className="btn-secondary"
          onClick={testMISAConnection}
        >
          🔗 Test MISA
        </button>
        <button 
          className="btn-primary"
          onClick={() => {
            setEditingRule(null);
            resetForm();
            setShowModal(true);
          }}
        >
          + Tạo Rule Mới
        </button>
      </div>
    </div>

        <div className="rules-list">
          {rules.length === 0 ? (
            <div className="empty-state">
              <p>Chưa có automation rule nào.</p>
              <p>Tạo rule để tự động gửi ZNS khi có sự kiện!</p>
            </div>
          ) : (
            <table className="rules-table">
              <thead>
                <tr>
                  <th>Tên Rule</th>
                  <th>Loại</th>
                  <th>Template</th>
                  <th>Điều kiện</th>
                  <th>Trạng thái</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {rules.map(rule => (
                  <tr key={rule.id}>
                    <td>
                      <strong>{rule.rule_name}</strong>
                      <br />
                      <small>Priority: {rule.priority}</small>
                    </td>
                    <td>
                      <span className={`badge badge-${rule.rule_type}`}>
                        {ruleTypes.find(t => t.value === rule.rule_type)?.label || rule.rule_type}
                      </span>
                    </td>
                    <td>
                      {rule.template_name}
                      <br />
                      <small className="text-muted">ID: {rule.zalo_template_id}</small>
                    </td>
                    <td>
                      <code className="conditions-code">
                        {JSON.parse(rule.trigger_conditions).delivery_status?.join(', ') || 'N/A'}
                      </code>
                    </td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={rule.enabled === 1}
                          onChange={() => handleToggle(rule.id)}
                        />
                        <span className="slider"></span>
                      </label>
                      <span className={rule.enabled ? 'status-active' : 'status-inactive'}>
                        {rule.enabled ? 'Hoạt động' : 'Tắt'}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="btn-edit"
                        onClick={() => handleEdit(rule)}
                      >
                        Sửa
                      </button>
                      <button 
                        className="btn-delete"
                        onClick={() => handleDelete(rule.id)}
                      >
                        Xóa
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Modal tạo/sửa rule */}
        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>{editingRule ? 'Sửa Automation Rule' : 'Tạo Automation Rule Mới'}</h2>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Tên Rule *</label>
                  <input
                    type="text"
                    value={formData.rule_name}
                    onChange={(e) => setFormData({...formData, rule_name: e.target.value})}
                    placeholder="VD: Gửi ZNS cảm ơn sau khi giao hàng"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Loại Rule *</label>
                  <select
                    value={formData.rule_type}
                    onChange={(e) => setFormData({...formData, rule_type: e.target.value})}
                    required
                  >
                    {ruleTypes.map(type => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Template ZNS *</label>
                  <select
                    value={formData.template_id}
                    onChange={(e) => handleTemplateChange(e.target.value)}
                    required
                  >
                    <option value="">-- Chọn template --</option>
                    {templates.map(template => (
                      <option key={template.id} value={template.id}>
                        {template.template_name} (ID: {template.template_id})
                      </option>
                    ))}
                  </select>
                </div>

                {formData.rule_type === 'order_delivered' && (
                  <div className="form-group">
                    <label>Trạng thái giao hàng kích hoạt *</label>
                    <div className="checkbox-group">
                      {['Đã giao hàng', 'Hoàn thành', 'Completed', 'Delivered'].map(status => (
                        <label key={status} className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={formData.delivery_statuses.includes(status)}
                            onChange={(e) => handleStatusChange(status, e.target.checked)}
                          />
                          {status}
                        </label>
                      ))}
                    </div>
                    {renderConditionsPreview()}
                  </div>
                )}

                {/* Field Mapping */}
                {selectedTemplate && (
                  <div className="form-group">
                    <label>Mapping Template Params → MISA Fields</label>
                    {loadingMisaFields ? (
                      <div className="loading-fields">Đang tải MISA fields...</div>
                    ) : (
                      <div className="mapping-table">
                        <table>
                          <thead>
                            <tr>
                              <th>Template Param</th>
                              <th>→</th>
                              <th>MISA Field</th>
                            </tr>
                          </thead>
                          <tbody>
                            {JSON.parse(selectedTemplate.params || '[]').map(param => {
                              const paramName = param.name || param;
                              return (
                                <tr key={paramName}>
                                  <td>
                                    <code>{paramName}</code>
                                    {param.example && (
                                      <small className="param-example">
                                        VD: {param.example}
                                      </small>
                                    )}
                                  </td>
                                  <td>→</td>
                                  <td>
                                    <select
                                      value={fieldMappings[paramName] || ''}
                                      onChange={(e) => handleMappingChange(paramName, e.target.value)}
                                      className="mapping-select"
                                      required
                                    >
                                      <option value="">-- Chọn field từ MISA --</option>
                                      {misaFields[formData.rule_type]?.map(field => (
                                        <option key={field.name} value={field.name}>
                                          {field.label} ({field.name})
                                          {field.example && ` - VD: ${field.example}`}
                                        </option>
                                      ))}
                                      <option value="_custom">✏️ Nhập thủ công</option>
                                    </select>
                                    
                                    {fieldMappings[paramName] === '_custom' && (
                                      <input
                                        type="text"
                                        placeholder="VD: contact_name|account_name"
                                        className="custom-mapping-input"
                                        onChange={(e) => handleMappingChange(paramName, e.target.value)}
                                      />
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div className="mapping-help">
                      <strong>💡 Tips:</strong>
                      <ul>
                        <li>Dùng <code>|</code> để fallback: <code>contact_name|account_name</code></li>
                        <li>Dùng <code>[]</code> để lấy từ array: <code>sale_order_product_mappings[].product_code</code></li>
                      </ul>
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <label>Độ ưu tiên</label>
                  <input
                    type="number"
                    value={formData.priority}
                    onChange={(e) => setFormData({...formData, priority: e.target.value})}
                    min="1"
                    max="100"
                  />
                  <small>Số nhỏ = ưu tiên cao hơn</small>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.enabled}
                      onChange={(e) => setFormData({...formData, enabled: e.target.checked})}
                    />
                    Kích hoạt ngay
                  </label>
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>
                    Hủy
                  </button>
                  <button type="submit" className="btn-primary">
                    {editingRule ? 'Cập nhật' : 'Tạo Rule'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </> // Thẻ đóng Fragment
);
}

export default AutomationRules;